
import Data    from 'fn/data.js';
import cache   from 'fn/cache.js';
import matches from 'fn/matches.js';
import prepad  from 'fn/prepad.js';

import messages from '../../messages/module.js';
import update  from '../modules/update.js';
import { retrieve } from '../modules/resource.js';


const products = Data.of([]);

export default products;

const types = {
    font:     0,
    variable: 1,
    pack:     2,
    cut:      3,
    lab:      4,
    custom:   5
};


// updateProducts(object)
//
// Finds a product, updates and returns it, or if no existing product is found,
// inserts object into products and returns it.
function identify(product) {
    return types[product.type] + product.type + '-' + product.pk;
}

function updateProducts(source) {
    return update(identify, products, source);
}

function processFont(data) {
    // Turn font object into flat array
    return data.font.concat(data.cart).map(processProduct);
}

function processProduct(product) {
    // Remove unused properties
    delete product.carted;
    return product;
}

export const requestFont = cache(function requestFont(pk) {
    if(!pk) {
        throw new Error('Wont request font without a pk!');
    }

    return retrieve('/api/v1/fonts/' + pk)
    .catch(messages.push)
    .then((data) => processFont(data).map(updateProducts));
});

export const requestCustom = cache(function requestCustom(pk) {
    if (!pk) {
        throw new Error('Wont request custom without a pk!');
    }

    const promise = retrieve('/api/v1/custom/' + pk);
    promise.catch(messages.push);

    return promise
    .then((data) => processFont(data).map(updateProducts));
});

export const requestCartedFonts = cache(function requestCartedFonts() {
    return retrieve('/api/v1/fonts/carted')
    .catch(messages.push)
    .then((data) => processFont(data).map(updateProducts));
});
